export const en = {
  // STEP 1
  headlineStep1: 'Join Unisport',
  email: 'Enter e-mail',
  confirmConsentText: 'Please confirm your consent.',
  ctaSignup: 'SUBSCRIBE',
  shortPermissionText:
    'I agree to receiving personlised offers, promotions and discounts from Unisport through the channels I select, such as e-mail, sms or direct mail. I can always withdraw my consent.',
  consent: 'Read more about your consent.',
  privacyPolicy: 'Read our privacy policy.',
  fullConsentText: '',
  privacyTerms: '',
  consentLink: '',
  privacyLink: 'https://www.unisportstore.com/policies/privacy/',

  // STEP 2
  headlineStep2: 'I am interested in:',
  ctaUpdate: 'UPDATE',
  ctaNext: 'Continue',

  // Errors
  error1: 'Please enter a valid e-mail address',
  error2: 'An error occured. Please try again.',
  error3: 'Please enter a valid e-mail address.',
  error4: 'A user with this email address already exists.',
  error5:
    'We are sorry, we are unable to complete your sign-up right now. Please try again.',
  error6: 'Sorry. You are already subscribed with this email address.',
  error7: 'This field is required.',
};

export const da = {
  // STEP 1
  introTitle: 'Elsker du fodbold?',
  introText:
    'Gå aldrig glip af de seneste fodbold tilbud, rabatkoder og nyeste lanceringer.',
  headlineStep1: 'Bliv en del af Unisport',
  email: 'Indtast e-mail',
  confirmConsentText: 'Bekræft venligst dit samtykke.',
  ctaSignup: 'TILMELD',
  shortPermissionText:
    'Ja tak, jeg vil gerne modtage gode og personaliserede tilbud på nyheder og konkurrencer fra Unisport og accepterer betingelserne.',
  consent: 'Læs betingelser.',
  privacyPolicy: 'Se privatlivsvilkår.',
  fullConsentText: '',
  privacyTerms: '',
  consentLink: '',
  privacyLink: 'https://www.unisport.dk/policies/privacy/',

  // STEP 2
  headlineStep2: 'Jeg interesserer mig for:',
  ctaUpdate: 'OPDATER',
  ctaNext: 'Fortsæt',

  // STEP 3
  headlineStep3: 'Tak fordi du tilmeldte dig!',
  altHeadline: 'Næsten færdig',
  subHeadline: 'Du er nu tilmeldt',
  altSubHeadline:
    'Bekræft venligst din tilmelding i den e-mail vi har sendt dig.',
  confirmation1:
    'Vi gør vores ypperste for at være relevante og inspirerende i alt vi sender dig.',
  confirmation2:
    'Du kan altid ændre hvordan du modtager information fra os og tilmelde dig som medlem af vores fordelsklub Unisport FC på unisport.dk/login.',
  confirmation3:
    'Nu hvor du er på vores liste, vil vi holde dig opdateret med nyheder, inspiration og eksklusive tilbud.',

  // Errors
  error1: 'Skriv venligst din e-mail adresse igen',
  error2: 'Der er sket en fejl. Prøv venligst igen.',
  error3: 'Indtast venligst en valid e-mail adresse.',
  error4: 'En bruger med denne e-mail adresse findes allerede.',
  error5:
    'Vi kan desværre ikke gennemføre din tilmelding lige nu. Prøv venligst igen.',
  error6: 'Vi beklager. Du er allerede tilmeldt med denne e-mail adresse.',
  error7: 'Dette felt er obligatorisk.',
};

export const sv = {
  // STEP 1
  introTitle: 'Älskar du fotboll?',
  introText:
    'Missa aldrig de senaste fotbollserbjudandena, rabattkoderna och nyaste produkterna.',
  headlineStep1: 'Bli en del av Unisport',
  email: 'Skriv in din mejladress',
  confirmConsentText: 'Vänligen bekräfta ditt godkännande.',
  ctaSignup: 'REGISTRERA DIG',
  shortPermissionText:
    'Ja tack, jag vill gärna ta emot bra och personaliserade erbjudanden från Unisport via de kanaler jag väljer, exempelvis e-post, brev eller sms. Jag kan ångra mitt godkännande när som helst.',
  consent: 'Läs mer om ditt godkännande.',
  privacyPolicy: 'Läs vår sekretesspolicy.',
  fullConsentText: '',
  privacyTerms: '',
  consentLink: '',
  privacyLink: 'https://www.unisportstore.se/policies/privacy/',

  // STEP 2
  headlineStep2: 'Jag är intresserad av:',
  ctaUpdate: 'UPPDATERA',
  ctaNext: 'Fortsätt',

  // STEP 3
  headlineStep3: 'Tack för att du registrerade dig!',
  altHeadline: 'Nästan klar',
  subHeadline: 'Du är nu registrerad',
  altSubHeadline:
    'Vänligen bekräfta din registrering i mejlet som vi har skickat till dig.',
  confirmation1:
    'Vi gör vårt yttersta för att vara relevanta och inspirerande i allt vi skickar till dig.',
  confirmation2:
    'Du kan alltid ändra hur du får information från oss och registrera dig som medlem i vår förmånsklubb Unisport FC på unisportstore.se/login.',
  confirmation3:
    'Nu när du prenumererar på vårt nyhetsbrev håller vi dig uppdaterad med de senaste nyheterna, inspiration och exklusiva fotbollserbjudanden.',

  // Errors
  error1: 'Vänligen bekräfta din mejladress',
  error2: 'Ett fel har inträffat. Prova igen.',
  error3: 'Skriv in en giltig mejladress',
  error4: 'Det finns redan en användare registrerad med denna mejladressen.',
  error5:
    'Vi kan tyvärr inte genomföra din registrering just nu. Vänligen prova igen.',
  error6: 'Du är redan registrerad med denna mejladress.',
  error7: 'Detta fält är obligatoriskt.',
};

export const nb = {
  // STEP 1
  introTitle: 'Elsker du fotball?',
  introText:
    'Gå ikke glipp av de siste tilbudene, rabattkoder og nyeste lanseringer.',
  headlineStep1: 'Bli en del av Unisport',
  email: 'Skriv inn e-posten din',
  confirmConsentText: 'Vennligst bekreft godkjennelsen din.',
  ctaSignup: 'REGISTRER DEG',
  shortPermissionText:
    'Ja takk, jeg vil gjerne motta gode og personaliserte tilbud fra Unisport via de kanalene jeg velger. F.eks. e-post, brev eller SMS. Jeg kan angre på min godkjennelse når som helst.',
  consent: 'Les mer om godkjennelsen din.',
  privacyPolicy: 'Les vårt personvern.',
  fullConsentText: '',
  privacyTerms: '',
  consentLink: '',
  privacyLink: 'https://www.unisportstore.no/policies/privacy/',

  // STEP 2
  headlineStep2: 'Jeg er interessert i:',
  ctaUpdate: 'OPPDATER',
  ctaNext: 'Fortsett',

  // STEP 3
  headlineStep3: 'Takk for at du registrerte deg!',
  altHeadline: 'Nesten ferdig',
  subHeadline: 'Du er nå registrert',
  altSubHeadline: 'Vennligst bekreft registreringen i mailen vi har sendt deg.',
  confirmation1:
    'Vi gjør vårt ypperste for å være relevant og inspirerende med alt vi sender til deg.',
  confirmation2:
    'Du kan når som helst endre på hvordan du mottar informasjon fra oss og registrere deg som medlem av vår fordelsklubb Unisport FC på unisportstore.no/login.',
  confirmation3:
    'Nå når du er på listen holder vi deg oppdatert på de nyeste lanseringene, inspirasjon og eksklusive tilbud.',

  // Errors
  error1: 'Vennligst skriv e-posten din igjen',
  error2: 'Det har skjedd en feil, vennligst prøv igjen.',
  error3: 'Skriv en gyldig mailadresse.',
  error4: 'Det finnes allerede en bruker med denne mailadressen.',
  error5:
    'Vi kan dessverre ikke gjennomføre registreringen din akkurat nå. Vennligst prøv igjen.',
  error6: 'Vi beklager. Du er allerede registrert med denne mailadressen.',
  error7: 'Dette feltet er obligatorisk. ',
};

export const fi = {
  // STEP 1
  introTitle: 'Rakastatko jalkapalloa?',
  introText:
    'Älä missaa viimeisimpiä jalkapallotarjouksia, alennuskoodeja ja uusimpia tuotteita.',
  headlineStep1: 'Liity Unisportiin',
  email: 'Aseta sähköpostiosoite',
  confirmConsentText: 'Ole hyvä ja vahvista suostumus.',
  ctaSignup: 'TILAA',
  shortPermissionText:
    'Hyväksyn, että vastaanotan henkilökohtaisia tarjouksia, mainoksia ja alennuksia Unisportilta kanavista, jotka valitsen, kuten sähköposti, tekstiviestit tai kirjeet. Voin aina peruuttaa suostumukseni.',
  consent: 'Lue lisää suostumuksestasi.',
  privacyPolicy: 'Lue yksityisyyden suojastamme.',
  fullConsentText: '',
  privacyTerms: '',
  consentLink: '',
  privacyLink: 'https://www.unisportstore.fi/policies/privacy/',

  // STEP 2
  headlineStep2: 'Minua kiinnostaa:',
  ctaUpdate: 'PÄIVITÄ',
  ctaNext: 'Jatka',

  // STEP 3
  headlineStep3: 'Kiitos ilmoittautumisesta!',
  altHeadline: 'Melkein valmista',
  subHeadline: 'Olet nyt rekisteröitynyt',
  altSubHeadline:
    'Ole hyvä ja vahvista ilmoittautumisesi sähköpostissa, jonka juuri lähetimme sinulle.',
  confirmation1:
    'Nyt kun olet listallamme, tulemme pitämään sinut ajant asalla uutuustuotteista, inspiraation lähteistä ja eksklusiivisista jalkapallotarjouksista.',
  confirmation2:
    'Voit vaihtaa profiilisi asetuksia ja tulla jäseneksi Unisportin etukerhoon osoitteessa unisportstore.fi/login.',
  confirmation3:
    'Nyt kun olet sähköpostilistallamme, niin tulemme pitämään sinut ajantasalla uusimmista tuotteista, inspiraation lähteistä ja jalkapallotuotteiden tarjouksista.',

  // Errors
  error1: 'Aseta voimassaoleva sähköpostiosoite',
  error2: 'Tapahtui virhe. Ole hyvä ja yritä uudelleen.',
  error3: 'Ole hyvä ja aseta voimassaoleva sähköpostiosoite.',
  error4: 'Tällä sähköpostiosoitteella on jo rekisteröitynyt käyttäjä.',
  error5:
    'Olemme pahoillamme, emme pysty viimeistelemään ilmoittautumistasi juuri nyt. Ole hyvä ja yritä uudelleen.',
  error6: 'Pahoittelemme. Olet jo ilmoittautunut tällä sähköpostiosoitteella.',
  error7: 'Tämä kenttä on pakollinen.',
};

export const nl = {
  // STEP 1
  introTitle: 'Gek op voetbal?',
  introText: 'Loop geen enkele aanbieding, kortingscode of release mis.',
  headlineStep1: 'Sluit je aan bij Unisport',
  email: 'E-mail invoeren',
  confirmConsentText: 'Bevestig alsjeblieft je toestemming.',
  ctaSignup: 'INSCHRIJVEN',
  shortPermissionText:
    'Ik ga akkoord met het ontvangen van persoonlijke aanbiedingen, promoties en kortingen van Unisport via de kanalen die ik selecteer, zoals per e-mail, sms of post. Ik kan altijd mijn toestemming intrekken.',
  consent: 'Lees meer over je toestemming.',
  privacyPolicy: 'Lees ons privacy beleid.',
  fullConsentText: '',
  privacyTerms: '',
  consentLink: '',
  privacyLink: 'https://www.unisportstore.nl/policies/privacy/',

  // STEP 2
  headlineStep2: 'Minua kiinnostaa:',
  ctaUpdate: 'UPDATEN',
  ctaNext: 'Ga verder',

  // STEP 3
  headlineStep3: 'Bedankt voor het aanmelden!',
  altHeadline: 'Bijna klaar',
  subHeadline: 'Je bent nu aangemeld',
  altSubHeadline:
    'Bevestig alsjeblieft je aanmelding via de e-mail die we je zojuist hebben gestuurd.',
  confirmation1:
    'Nu je je hebt aangemeld, houden wij je op de hoogte van nieuwe producten, inspiraties en exclusieve voetbal aanbiedingen.',
  confirmation2:
    'Je kan altijd je profiel instellingen aanpassen en lid worden van de Unisport FC voordeelclub via unisportstore.nl/login.',
  confirmation3:
    'Nu je je hebt ingeschreven houden wij je op de hoogte van de nieuwste releases, inspiraties en exclusieve deals.',

  // Errors
  error1: 'Voer alsjeblieft een geldig e-mailadres in',
  error2: 'Er is iets misgegaan. Probeer het nog eens.',
  error3: 'Voer alsjeblieft een geldig e-mailadres in.',
  error4: 'Er bestaat al een gebruiker met dit e-mailadres.',
  error5:
    'Sorry, het is momenteel niet mogelijk om je inschrijving af te ronden. Probeer het alsjeblieft nog eens.',
  error6: 'Sorry. Je bent al ingeschreven met dit e-mailadres.',
  error7: 'Dit veld is verplicht.',
};

export const fr = {
  // STEP 1
  introTitle: 'Vous adorez le football?',
  introText:
    'Ne ratez plus aucune offres spéciales, codes promo et nouveautés produits.',
  headlineStep1: 'Rejoignez Unisport',
  email: 'Entrer votre email',
  confirmConsentText: 'Veuillez confirmer votre accord.',
  ctaSignup: 'INSCRIPTION',
  shortPermissionText:
    'J´accepte de recevoir des offres personnalisées, promotions et réductions de la part d´Unisport au travers des chaînes que je sélectionne, email, sms, courrier. Je peux toujours retirer mon consentement.',
  consent: 'Lire plus sur votre accord.',
  privacyPolicy: 'Veuillez confirmer votre accord.',
  fullConsentText: '',
  privacyTerms: '',
  consentLink: '',
  privacyLink: 'https://www.unisportstore.fr/policies/privacy/',

  // STEP 2
  headlineStep2: 'Je suis intéressé par:',
  ctaUpdate: 'METTRE À JOUR',
  ctaNext: 'Continuer',

  // STEP 3
  headlineStep3: 'Merci pour votre inscription!',
  altHeadline: 'Presque terminé',
  subHeadline: 'Vous êtes maintenant inscrit',
  altSubHeadline:
    'Veuillez confirmer votre inscription grâce à l´email que nous venons de vous envoyer.',
  confirmation1:
    'J´deaccepte de recevoir des offres personnalisées, promotions et réductions de la part d´Unisport au travers des chaînes que je sélectionne, email, sms, courrier. Je peux toujours retirer mon consentement.',
  confirmation2:
    'Vous pouvez modifier votre profil et vos préférences pour devenir membre du club Unisport FC en allant sur unisportstore.com/login.',
  confirmation3:
    'Maintenant que vous êtes inscrit nous vous tiendrons au courant de toutes les nouveautés et offres spéciales.',

  // Errors
  error1: 'Veuillez entrer une adresse email valide',
  error2: 'Une erreur est apparue. Veuillez réessayer',
  error3: 'Veuillez entrer une adresse email valide',
  error4: 'Un utilisateur avec cette adresse existe déjà.',
  error5:
    'Nous sommes désolés, votre inscription ne peut pas être complétée maintenant. Veuillez réessayer',
  error6: 'Désolé. Vous êtes déjà inscrit avec cette adresse email.',
  error7: 'Ce champs est requis.',
};

export const de = {
  // STEP 1
  introTitle: 'Liebst du Fußball?',
  introText:
    'Verpasse keine Fußball-Angebote, Gutscheincodes oder die neuesten Produkte.',
  headlineStep1: 'Werde ein Teil von Unisport',
  email: 'Email eingeben',
  confirmConsentText: 'Bitte bestätige deine Einwilligung.',
  ctaSignup: 'ABONNIEREN',
  shortPermissionText:
    'Ich stimme zu, persönliche Angebote, Werbung und Rabatte von Unisport über den Kanal zu erhalten, welchen ich ausgewählt habe. Ich kann meine Einwilligung jederzeit widerrufen.',
  consent: 'Lese mehr über deine Einwilligung.',
  privacyPolicy: 'Lese unsere Datenschutzbestimmungen.',
  fullConsentText: '',
  privacyTerms: '',
  consentLink: '',
  privacyLink: 'https://www.unisportstore.de/policies/privacy/',

  // STEP 2
  headlineStep2: 'Ich interessiere mich für:',
  ctaUpdate: 'Aktualisieren',
  ctaNext: 'Fortsetzen',

  // STEP 3
  headlineStep3: 'Danke für deine Anmeldung!',
  altHeadline: 'Fast geschafft',
  subHeadline: 'Du bist jetzt angemeldet',
  altSubHeadline:
    'Bitte bestätige die Anmeldung in der Email, die wir dir soeben geschickt haben',
  confirmation1:
    'Du bist jetzt angemeldet und erhältst Informationen zu Neuerscheinungen, exklusiven Angeboten und Inspiration.',
  confirmation2:
    'Du kannst deine Profil-Einstellungen anpassen und auf unisportstore.com/login ein Mitglied des Unisport-Clubs werden.',
  confirmation3:
    'Jetzt wo du für unseren Newsletter angemeldet bist werden wir dich regelmäßig über neue Veröffentlichungen, Neuheiten und exklusive Fußball-Angebote informieren.',

  // Errors
  error1: 'Bitte gebe eine gültige Email ein',
  error2: 'Es ist ein Fehler aufgetreten. Bitte versuche es erneut.',
  error3: 'Bitte gebe eine gültige Email ein.',
  error4: 'Es exisitert bereits ein Benutzer mit dieser Email.',
  error5:
    'Bitte entschuldige, wir können deine Anmeldung zurzeit nicht abschließen. Bitte versuche es später erneut.',
  error6: 'Du bist bereits mit dieser Email angemeldet.',
  error7: 'Dieses Feld ist erforderlich.',
};

export const at = {
  // STEP 1
  introTitle: 'Liebst du Fußball?',
  introText:
    'Verpasse keine Fußball-Angebote, Gutscheincodes oder die neuesten Produkte.',
  headlineStep1: 'Werde ein Teil von Unisport',
  email: 'Email eingeben',
  confirmConsentText: 'Bitte bestätige deine Einwilligung.',
  ctaSignup: 'ABONNIEREN',
  shortPermissionText:
    'Ich stimme zu, persönliche Angebote, Werbung und Rabatte von Unisport über den Kanal zu erhalten, welchen ich ausgewählt habe. Ich kann meine Einwilligung jederzeit widerrufen.',
  consent: 'Lese mehr über deine Einwilligung.',
  privacyPolicy: 'Lese unsere Datenschutzbestimmungen.',
  fullConsentText: '',
  privacyTerms: '',
  consentLink: '',
  privacyLink: 'https://www.unisportstore.de/policies/privacy/',

  // STEP 2
  headlineStep2: 'Ich interessiere mich für:',
  ctaUpdate: 'Aktualisieren',
  ctaNext: 'Fortsetzen',

  // STEP 3
  headlineStep3: 'Danke für deine Anmeldung!',
  altHeadline: 'Fast geschafft',
  subHeadline: 'Du bist jetzt angemeldet',
  altSubHeadline:
    'Bitte bestätige die Anmeldung in der Email, die wir dir soeben geschickt haben',
  confirmation1:
    'Du bist jetzt angemeldet und erhältst Informationen zu Neuerscheinungen, exklusiven Angeboten und Inspiration.',
  confirmation2:
    'Du kannst deine Profil-Einstellungen anpassen und auf unisportstore.com/login ein Mitglied des Unisport-Clubs werden.',
  confirmation3:
    'Jetzt wo du für unseren Newsletter angemeldet bist werden wir dich regelmäßig über neue Veröffentlichungen, Neuheiten und exklusive Fußball-Angebote informieren.',

  // Errors
  error1: 'Bitte gebe eine gültige Email ein',
  error2: 'Es ist ein Fehler aufgetreten. Bitte versuche es erneut.',
  error3: 'Bitte gebe eine gültige Email ein.',
  error4: 'Es exisitert bereits ein Benutzer mit dieser Email.',
  error5:
    'Bitte entschuldige, wir können deine Anmeldung zurzeit nicht abschließen. Bitte versuche es später erneut.',
  error6: 'Du bist bereits mit dieser Email angemeldet.',
  error7: 'Dieses Feld ist erforderlich.',
};
